import {getPageById} from "../pages/layout/pageDefinition";
import {getNavState, setNavState} from "../utils/constants";


const delay = (time) => new Promise((resolve) => setTimeout(() => resolve(), time));

const getSelectedMenuId = (id) => {
    let selectedMenuId = id;
    let ids = id.split("-");
    if (ids.length === 3) {//如果有父节点，选中父节点
        selectedMenuId = ids[0] + "-" + ids[1];
    }
    return selectedMenuId;
}
const storeState = (state) => {
    const {num, navTabs, navSelected, menuSelected} = state;
    setNavState({num, navTabs, navSelected, menuSelected});
}
const cacheAble = false;
const initState = cacheAble ? getNavState() : null;
const nav = {
    state: {
        num: initState ? initState.num : 0,
        navTabs: initState ? initState.navTabs : [
            {
                "id": "1",
                "path": "/",
                "name": "首页",
                "parent": null,
                "closable": false
            }
        ],
        navSelected: initState ? initState.navSelected : "1",
        menuSelected: initState ? initState.menuSelected : "1",
    },

    reducers: {
        initState(state, payload) {
            if (payload) {
                state.num = payload.num;
                state.navTabs = payload.navTabs;
                state.navSelected = payload.navSelected;
                state.menuSelected = getSelectedMenuId(payload.navSelected);
            }
        },
        inc: (state) => {
            state.num++;
        },
        dec: (state) => {
            state.num--;
        },
        routerChange: (state, id) => {
            const retArr = state.navTabs.filter(el => el.id === id);
            if (retArr && retArr.length > 0) {//存在
                state.navSelected = id;
            } else {//不存在
                const page = getPageById(id);
                if (page) {
                    state.navTabs.push(page);
                    state.navSelected = id;
                }
            }
            state.menuSelected = getSelectedMenuId(id);
            if (cacheAble) storeState(state);
        },
        selectNav: (state, id) => {
            if (state.navSelected !== id) {
                state.navSelected = id;
            }
            state.menuSelected = getSelectedMenuId(id);
            if (cacheAble) storeState(state);

        },
        closeNav: (state, id) => {
            //如果id为空，关闭当前选择的页签
            if (!!!id) {
                id = state.navSelected;
            }
            state.navTabs = state.navTabs.filter(el => el.id !== id);
            //如果关闭的页签是当前选中的页签
            if (state.navSelected === id) {
                let lastSelectedId = state.navTabs[state.navTabs.length - 1].id;
                state.navSelected = lastSelectedId;
                state.menuSelected = getSelectedMenuId(lastSelectedId);
            }
            /*const {num, navTabs, navSelected} = state;
            setNavState({num, navTabs, navSelected});*/
            if (cacheAble) storeState(state);
        }
    },

    effects: () => ({
        async onChagne() {

        },
        async serialize() {//序列化

        },
        async deserialize() {//反序列化

        },
        async asyncDec() {
            await delay(100);
            this.inc();
        }
    })

}
export {nav}